/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useEffect, useRef, useState } from "react";
import { useAuthContext } from "../../../context/authContext";
import { useOrganizationContext } from "../../../context/organization-context";
import useAPIHandler from "../../../hook/use-api-handler";
import useSnackbar from "../../../hook/use-snakbar";
import {
  getDateProperFormatForInput,
  getInputFieldProps,
  removeUnderScrSpCharSpaceBet,
  safeToString,
} from "../../../utils/common";
import {  removeMultipleSpace, safeString } from "../../../utils/logger";
import {
  ALLOWANCE_ACT_STATE,
  INDUSTRY_TYPE,
  ORGANIZATION_CATEGORY,
  ORGANIZATION_FORM_FIELDS,
  ORGANIZATION_INITIAL_STATE,
} from "./profile-contants";
import { schema } from "./profile-validation";


const useOrganisationService = () => {
  const fileInputRef = useRef(null);
  const {
    orgDetails: fromGblobalorgDetails,
    getOrganizationFn,
   
  } = useAuthContext();

  const {
    stateList
  }=useOrganizationContext()

  const {
    snackbarVisible,
    snackbarMessage,
    snackbarDuration,
    openSnackbar,
    closeSnackbar,
    snackColor,
  } = useSnackbar();
  const [orgProfile, setOrgProfile] = useState(ORGANIZATION_INITIAL_STATE);
 

  const [orgAcName, setOrgAcName] = useState([
    structuredClone(ALLOWANCE_ACT_STATE),
  ]);

  const [organizationFormFields] = useState(ORGANIZATION_FORM_FIELDS);

  const [errors, setErrors] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewURL, setPreviewURL] = useState(null);
  const { fetchData } = useAPIHandler();

  const [createUpdateLoading, setCreateUpdateLoading] = useState(false);
  const [getProfileLoading, setgetProfileLoading] = useState(false);

  const [orgDetailsModal, SetOrgDetailsModal] = useState(false);
  const handleOpenOrgDetailsModal = () => {
    resetOrganizationFormFn();
    setErrors({});
    SetOrgDetailsModal(true);
  };
  const handleCloseOrgDetailsModal = () => {
    SetOrgDetailsModal(false);
  };
  const [basicInfoModalOpen, setbasicInfoModalOpen] = useState(false);
  const handleOpenbasicInfoModal = () => {
    resetOrganizationFormFn();
    setErrors({});
    setbasicInfoModalOpen(true);
  };
  const handleClosebasicInfoModal = () => {
    setbasicInfoModalOpen(false);
  };
  const [orgActNameModal, SetOrgActNameModal] = useState(false);
  const handleOpenOrgActNameModal = () => {
    resetOrganizationFormFn();

    setErrors({});
    SetOrgActNameModal(true);
  };
  const handleCloseOrgActNameModal = () => {
    SetOrgActNameModal(false);
  };
  const [orgAddressModal, SetOrgAddressModal] = useState(false);
  const handleOpenOrgAddressModal = () => {
    resetOrganizationFormFn();

    setErrors({});
    SetOrgAddressModal(true);
  };
  const handleCloseOrgAddressModal = () => {
    SetOrgAddressModal(false);
  };


  const handleAddRow = () => {
    if (orgAcName.length !== 1) {
      const anyEmptyValue = orgAcName?.find(
        (it) => it.actName === "" || it.regNo === ""
      );

      if (anyEmptyValue) {
        openSnackbar({
          message:
            "Please add the act name and registration number to the previous row!",
          color: "danger",
        });
        return;
      } else {
        setOrgAcName([...orgAcName, structuredClone(ALLOWANCE_ACT_STATE)]);
      }
    } else {
      setOrgAcName([...orgAcName, structuredClone(ALLOWANCE_ACT_STATE)]);
    }
  };

  const handleDeleteRow = (index) => {
    const updatedList = orgAcName.filter((_, i) => i !== index);
    setOrgAcName(updatedList);
  };

  const handleChange = (index, field, value) => {
    const updatedList = [...orgAcName];
    if (field === "actName") {
      updatedList[index][field] = removeMultipleSpace(safeToString(value));
    } else {
      updatedList[index][field] = removeMultipleSpace(
        removeUnderScrSpCharSpaceBet(safeToString(value))
      );
    }

    setOrgAcName(updatedList);
  };

  function resetOrganizationFormFn() {
    const resData = { ...fromGblobalorgDetails, country: "India" };

    resData.date_of_org = getDateProperFormatForInput(
      fromGblobalorgDetails?.date_of_org
    );

    if (fromGblobalorgDetails?.pincode) {
      resData.pincode = safeString(fromGblobalorgDetails?.pincode);
    }
    setOrgProfile(resData);

    setOrgAcName(
      fromGblobalorgDetails?.org_acts?.length > 0
        ? fromGblobalorgDetails?.org_acts?.map((it) => ({
            ...it,
            actName: it?.act_name,
            regNo: it?.reg_no,
          }))
        : [structuredClone(ALLOWANCE_ACT_STATE)]
    );
    if (fromGblobalorgDetails?.logo && fromGblobalorgDetails?.path) {
      setPreviewURL(
       `${fromGblobalorgDetails?.path+fromGblobalorgDetails?.logo}`
      );
    }
    
  }

  useEffect(() => {
    if (fromGblobalorgDetails?.org_name) {
      const resData = { ...fromGblobalorgDetails, country: "India" };

      resData.date_of_org = getDateProperFormatForInput(
        fromGblobalorgDetails?.date_of_org
      );

      if (fromGblobalorgDetails?.pincode) {
        resData.pincode = safeString(fromGblobalorgDetails?.pincode);
      }
      setOrgProfile(resData);

      setOrgAcName(
        fromGblobalorgDetails?.org_acts?.length > 0
          ? fromGblobalorgDetails?.org_acts?.map((it) => ({
              ...it,
              actName: it?.act_name,
              regNo: it?.reg_no,
            }))
          : [structuredClone(ALLOWANCE_ACT_STATE)]
      );
      if (fromGblobalorgDetails?.logo && fromGblobalorgDetails?.path) {
        setPreviewURL(
          `${fromGblobalorgDetails?.path+fromGblobalorgDetails?.logo}`
        );
      }
    }
  }, [fromGblobalorgDetails]);

  const handleChangeFunction = (e, name) => {
    let value = e;
  
    if (e && e.target) {
      value = e.target.value;
    }
  
    if (
      ORGANIZATION_FORM_FIELDS[name].customOptions &&
      ORGANIZATION_FORM_FIELDS[name].customOptions?.formatValueFn
    ) {
      value = ORGANIZATION_FORM_FIELDS[name].customOptions?.formatValueFn(
        value,
        orgProfile
      );
    }

    if (name === 'payment_type') {
      if (typeof value === 'string') {
        value = value.split(',').map((item) => item.trim());
      } else if (!Array.isArray(value)) {
        value = [value];
      }
    }
  
    setOrgProfile((prevUser) => {
      const updatedProfile = { ...prevUser, [name]: value };
      if (name === 'payment_type' && (!e.includes("wages"))) {
        delete updatedProfile.wages_type;
        delete updatedProfile.wages_days;
      }
      if (name === 'wages_type' && (e==="monthly")) {
        delete updatedProfile.wages_days;
      }
  
      return updatedProfile;
    });
  
    const fieldSchema = schema.extract(name);
    const { error } = fieldSchema.validate(value, {
      context: {
        payment_type: name === 'payment_type' ? value : orgProfile.payment_type,
        wages_type: name === 'wages_type' ? value : orgProfile?.wages_type,
      },
    });
  
    if (!error) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }
  };
  
  const handleClick = async (_, submitDialogName) => {

    if (submitDialogName === "ACT_NO") {
      const anyEmptyValue = orgAcName?.find(
        (it) => it.actName === "" || it.regNo === ""
      );
  
      if (anyEmptyValue) {
        openSnackbar({
          message: "Please add the act name and registration number!",
          color: "danger",
        });
        return;
      }
    }
  
    setCreateUpdateLoading(true);
  
    const {
      org_name,
      landline,
      phone,
      email,
      domain_name,
      tan_no,
      pan,
      industry_type,
      registration_type,
      wages_days,
      date_of_org,
      payment_type,
      wages_type,
      address,
      locality,
      city,
      state,
      pincode,
      landmark,
    } = orgProfile;
  
    const { error, value } = schema.validate(
      {
        org_name,
        landline,
        phone,
        email,
        domain_name,
        tan_no,
        pan,
        industry_type,
        registration_type,
        state,
        date_of_org,
        payment_type,
        wages_type,
        address,
        locality,
        city,
        wages_days,
        pincode,
        landmark,
        domain_authorization: 1,
        country: "india",
      },
      {
        abortEarly: false,
        context: {
          payment_type,
          wages_type,
        },
      }
    );
  
  
    let validationErrors = {};
  
    if (error && error?.details?.length > 0) {
      validationErrors = error.details.reduce((acc, err) => {
        const pathname = err.path.join(".");
        acc[pathname] = err.message;
        return acc;
      }, {});
    }
  
    if (!orgProfile.payment_type.includes("wages")) {
      const { wages_type, ...resetErr } = validationErrors || {};
      validationErrors = { ...resetErr };
    }
  
    if (
      !orgProfile.payment_type.includes("wages") ||
      orgProfile.wages_type !== "fixed_date"
    ) {
      const { wages_days, ...resetErrs } = validationErrors || {};
      validationErrors = { ...resetErrs };
    }
  
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setCreateUpdateLoading(false);
    } else {
      setErrors({});
  
      const appendFormData = (formData, object, parentKey = "") => {
        for (const key in object) {
          const value = object[key];
          const formKey = parentKey ? `${parentKey}[${key}]` : key;
  
          if (Array.isArray(value)) {
            value.forEach((item, index) => {
              formData.append(`${formKey}[${index}]`, item);
            });
          } else if (typeof value === "object" && value !== null) {
            appendFormData(formData, value, formKey); 
          } else {
            formData.append(formKey, value); 
          }
        }
      };
      value.payment_type = Array.isArray(payment_type)
        ? payment_type
        : [payment_type];
  
      if (!payment_type.includes("wages") && value.wages_type !== "fixed_date") {
        delete value.wages_type;
        delete value.wages_days;
      }
      if (payment_type.includes("wages") && value.wages_type !== "fixed_date") {
        delete value.wages_days;
      }
  
      const data = new FormData();
  
      Object.keys(value).map((key) => {
        data.append(key, value[key] ?? "");
      });
  
      if (selectedFile) {
        data.append("logo", selectedFile);
      }
  
      if (orgAcName.length > 0) {
        const act = {
          act_name: orgAcName
            .filter((it) => it?.actName)
            .map((it) => it?.actName),
          reg_no: orgAcName.filter((it) => it?.regNo).map((it) => it?.regNo),
        };
        appendFormData(data, act, "act");
      }
  
      try {
        const res = await fetchData({
          data,
          url: "/organization/create-basic-information",
          method: "POST",
        });
  
        if (res?.data?.org_name) {
          openSnackbar({ message: "Organization updated successfully!" });
        }
       
        setCreateUpdateLoading(false);
        getOrganizationFn();
  
        setgetProfileLoading(false);
        handleCloseOrgAddressModal();
        handleCloseOrgDetailsModal();
        handleClosebasicInfoModal();
        handleCloseOrgActNameModal();
      } catch (error) {
        if (error?.type === "JoiValidationError") {
          const errorsAll = {};
  
          error?.errors?.map((item) => {
            const { field, message } = item;
            errorsAll[field] = message;
          });
  
          openSnackbar({
            message:
              Object.keys(errorsAll).length > 0
                ? "Validation Error!"
                : "Something went wrong!",
            color: "danger",
          });
          setErrors(errorsAll);
        }
        setCreateUpdateLoading(false);
      }
    }
  };
  






  function handleBlurFn(e, name) {
    let value = e;

    if (e && e.target) {
      value = e.target.value;
    }

    const fieldSchema = schema.extract(name);
    const { error } = fieldSchema.validate(value, {
      context: {
        payment_type: orgProfile.payment_type,
        wages_type:orgProfile?.wages_type
      },
    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error ? error.details[0].message : undefined,
    }));
  }

  const getInputFieldPropsFn = (fieldName = "") => {
    const { customOptions = {}, ...restProps } =
      ORGANIZATION_FORM_FIELDS[fieldName] || {};

    const error = safeToString(errors[fieldName]);
    const props = {
      ...restProps,
      ...getInputFieldProps({
        name: fieldName,
        stateValues: orgProfile,
        type: restProps.type || "text",
        error,
        handleBlurFn,
        handleChangeFunction,
      }),
    };

    return props;
  };



  function getOrganizationCategoryName(id) {
    const category = ORGANIZATION_CATEGORY.find(item => item.id === id);
    return category ? category.name : 'N/A';
  }
  function getOrganizationIndustryType(id) {
    const industryType = INDUSTRY_TYPE.find(item => item.id === id);
    return industryType ? industryType.name : 'N/A';
  }
  function getStateName(id) {
    const stateName = stateList.find(item => item.id === id);

    return stateName ? stateName?.name : 'N/A'
  }
  return {
    handleChangeFunction,
    snackbarVisible,
    snackbarMessage,
    snackbarDuration,
    openSnackbar,
    closeSnackbar,
    orgProfile,
    errors,
    handleClick,
    orgAcName,
    handleChange,
    handleAddRow,
    handleDeleteRow,
    fileInputRef,
    previewURL,
    setPreviewURL,
    selectedFile,
    setSelectedFile,
    organizationFormFields,
    stateList,
    setOrgProfile,
    createUpdateLoading,
    getInputFieldProps: getInputFieldPropsFn,
    snackColor,
    getProfileLoading,
    resetOrganizationFormFn,
    setErrors,

    handleOpenOrgDetailsModal,
    handleCloseOrgDetailsModal,
    handleOpenOrgActNameModal,
    handleCloseOrgActNameModal,
    handleOpenOrgAddressModal,
    handleCloseOrgAddressModal,
    orgDetailsModal,
    orgActNameModal,
    orgAddressModal,
    basicInfoModalOpen,
    handleClosebasicInfoModal,
    handleOpenbasicInfoModal,
    getStateName,
    getOrganizationIndustryType,
    getOrganizationCategoryName
  };
};

export default useOrganisationService;
